import cx from 'classnames';
import { forwardRef } from 'react';

import { type ForwardRefComponent } from '../../@types/types';
import { type COLORS, type SIZES, type TINTS } from '../../constants';
import Box from '../box';
import { type BoxProps } from '../box/Box';

import * as theme from './theme.css';

export type LoadingSpinnerSize = Exclude<(typeof SIZES)[number], 'tiny' | 'large' | 'fullscreen' | 'smallest' | 'hero'>;

export interface LoadingSpinnerProps extends Omit<BoxProps, 'className' | 'size'> {
  /** A class name for the wrapper to add custom classes */
  className?: string;
  /** The color of the components */
  color?: (typeof COLORS)[number];
  /** Size of the component */
  size?: LoadingSpinnerSize;
  /** The tint of the components color */
  tint?: (typeof TINTS)[number];
}
const LoadingSpinner: ForwardRefComponent<LoadingSpinnerProps> = forwardRef<HTMLElement, LoadingSpinnerProps>(
  ({ className, color = 'teal', size = 'medium', tint = 'darkest', ...others }, ref) => {
    const classNames = cx(
      theme['loading-spinner'],
      theme[`is-${color}`],
      theme[`is-${size}`],
      theme[`is-${tint}`],
      className,
    );
    return <Box data-teamleader-ui="loading-spinner" className={classNames} {...others} ref={ref} />;
  },
);

LoadingSpinner.displayName = 'LoadingSpinner';
export default LoadingSpinner;
